(function () {
	var SLIDER_ROOT_SELECTOR = ".product-card-js.swiper-container";
	var MAX_BULLET_SLIDES = 5;

	var navHoverBound = false;
	var cursorBoundCards = new WeakSet();

	function bindNavHoverOnce() {
		if (navHoverBound) return;
		navHoverBound = true;
		document.addEventListener("mouseover", function (event) {
			var buttonNext = event.target.closest(".button-next");
			if (!buttonNext) return;
			var swiperButton = buttonNext.querySelector(".swiper-button-next-1");
			var cursor = buttonNext.querySelector(".product__cursor");
			if (
				swiperButton &&
				swiperButton.classList.contains("swiper-button-disabled") &&
				cursor
			) {
				cursor.style.opacity = "0.5";
			}
		});
	}

	function bindCardCursor(productCard) {
		if (!(productCard instanceof Element) || cursorBoundCards.has(productCard)) return;
		var cursorIcon = productCard.querySelector("#cursor-icon1");
		if (!cursorIcon) return;
		cursorBoundCards.add(productCard);

		var animateCursor = function (e, cursor) {
			var contentRect = productCard.getBoundingClientRect();
			var x = e.clientX - contentRect.left - 12;
			var y = e.clientY - contentRect.top - 12;

			cursor.animate(
				{ transform: "translate(" + x + "px," + y + "px)" },
				{ duration: 300, fill: "forwards" },
			);
		};

		var getCursorClass = function (position, width) {
			return position < width / 2 ? "prev" : "next";
		};

		productCard.addEventListener("mousemove", function (e) {
			var cursor = productCard.querySelector(".product__cursor");
			if (!cursor) return;

			if (
				e.target.closest(".link") ||
				e.target.closest(".swiper-pagination")
			) {
				cursor.classList.remove("active");
			} else {
				cursor.classList.add("active");
			}

			animateCursor(e, cursor);

			var position =
				e.clientX - productCard.getBoundingClientRect().left;
			cursor.dataset.type = getCursorClass(
				position,
				productCard.clientWidth,
			);

			cursorIcon.className = cursor.dataset.type;
		});

		productCard.addEventListener("mouseleave", function () {
			var cursor = productCard.querySelector(".product__cursor");
			if (cursor) cursor.classList.remove("active");
		});
	}

	window.monochromeInitProductCardSwipers = function monochromeInitProductCardSwipers(
		root,
	) {
		var scope = root && root.querySelectorAll ? root : document;
		bindNavHoverOnce();

		scope
			.querySelectorAll(SLIDER_ROOT_SELECTOR + ":not(.slider_started)")
			.forEach(function (sliderEl) {
				var wrapper = sliderEl.querySelector(".swiper-wrapper");
				var slideCount = wrapper ? wrapper.children.length : 0;
				var paginationEl = sliderEl.querySelector(
					".product-card-pagination",
				);
				var nextEl = sliderEl.querySelector(".swiper-button-next-1");
				var prevEl = sliderEl.querySelector(".swiper-button-prev-1");

				sliderEl.classList.add("slider_started");

				if (slideCount <= 1) {
					if (paginationEl) paginationEl.hidden = true;
					return;
				}

				if (paginationEl) paginationEl.hidden = false;

				var loop = false;
				if (sliderEl.dataset.loop === "true") loop = true;
				else if (sliderEl.dataset.loop === "false") loop = false;

				var useFraction = slideCount > MAX_BULLET_SLIDES;

				if (paginationEl) {
					paginationEl.innerHTML = "";
					paginationEl.classList.toggle(
						"product-card-pagination--fraction",
						useFraction,
					);
					paginationEl.classList.remove(
						"swiper-pagination-bullets",
						"swiper-pagination-fraction",
					);
				}

				var paginationConfig =
					paginationEl &&
					(useFraction
						? { el: paginationEl, type: "fraction" }
						: { el: paginationEl, clickable: true });

				new Swiper(sliderEl, {
					slidesPerView: 1,
					speed: 650,
					spaceBetween: 2,
					loop: loop,
					observer: true,
					observeParents: true,
					watchOverflow: true,
					navigation:
						nextEl && prevEl ? { nextEl: nextEl, prevEl: prevEl } : undefined,
					pagination: paginationConfig ? paginationConfig : undefined,
				});

				var productCard = sliderEl.closest(".card--product_cursor");
				if (productCard) bindCardCursor(productCard);
			});
	};

	if (!window.__monochromeProductCardSliderBootstrapped) {
		window.__monochromeProductCardSliderBootstrapped = true;

		function bootSliders() {
			window.monochromeInitProductCardSwipers(document);
		}

		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", bootSliders);
		} else {
			bootSliders();
		}

		document.addEventListener("shopify:section:load", bootSliders);
	}
})();
